import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { JOURNAL_PLANNER_FEATURE_KEY, journeyPlannerReducer } from './state+/journey-planner.reducer';
import { JourneyPlannerEffects } from './state+/journey-planner.effects';
import { JourneyPlannerFacade } from './state+/journey-planner.facade';
import { JourneyPlannerService } from './journey-planner.service';

@NgModule({
    declarations: [],
    imports: [CommonModule, StoreModule.forFeature(JOURNAL_PLANNER_FEATURE_KEY, journeyPlannerReducer)],
    providers: [JourneyPlannerFacade, JourneyPlannerService, JourneyPlannerEffects]
})
export class JourneyPlannerModule {}
